import React, {lazy, Suspense} from 'react'

const DioceseParishesPageLazy = lazy(() =>
    import('./DioceseMainView')
)

const DioceseParishesPage = props => (
    <Suspense fallback={null}>
        <DioceseParishesPageLazy {...props} />
    </Suspense>
)

export default DioceseParishesPage
